import { render, staticRenderFns } from "./PeopleType.vue?vue&type=template&id=aacec444&scoped=true"
import script from "./PeopleType.vue?vue&type=script&lang=js"
export * from "./PeopleType.vue?vue&type=script&lang=js"
import style0 from "./PeopleType.vue?vue&type=style&index=0&id=aacec444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacec444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aacec444')) {
      api.createRecord('aacec444', component.options)
    } else {
      api.reload('aacec444', component.options)
    }
    module.hot.accept("./PeopleType.vue?vue&type=template&id=aacec444&scoped=true", function () {
      api.rerender('aacec444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cashinternal/PeopleType.vue"
export default component.exports